import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PortalAuthenticationService } from '../../service/b2b-portal/portal-authentication/portal-authentication.service';
import { ToastService } from '@shared/service/toast.service';
import { clearSession } from '@shared/utils/session.util';

export const b2bPortalAuthGuard: CanActivateFn = (route, state) => {
  const portalAuthenticationService = inject(PortalAuthenticationService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  if (portalAuthenticationService.isAuthenticated()) {
    return true;
  }

  router.navigate(['/login']);
  clearSession();
  toastService.showError(
    'Session abgelaufen, bitte melden Sie sich erneut an.'
  );
  return false;
};
